import PaymentGateway from '@src/services/payment-gateway';

const mutations = {
    SET_PAYMENT_GATEWAY_SUMMARIES(state, paymentGatewaySummaries) {
        state.paymentGatewaySummaries = paymentGatewaySummaries
    },
    SET_PAYMENT_GATEWAY_BALANCE_LOGS(state, balanceLogs) {
        state.balanceLogs = balanceLogs
    },
    SET_IS_FETCHING_PAYMENT_GATEWAY_BALANCE_LOGS(state, isFetching) {
        state.isFetchingBalanceLogs = isFetching
    },
    SET_PAYMENT_GATEWAY_BALANCE_LOG_ACTORS(state, actors) {
        state.balanceLogActors = actors
    }
}

const actions = {
    async getPaymentGatewaySummaries({ commit, dispatch }, { from, to }) {
        try {
            const paymentGatewaySummaries = await PaymentGateway.getSummary(from, to)
            commit('SET_PAYMENT_GATEWAY_SUMMARIES', paymentGatewaySummaries)
        } catch (e) {
            dispatch('notifyError', e)
        }
    },
    async getPaymentGatewayDetail({ dispatch }, id) {
        try {
            return await PaymentGateway.getDetail(id)
        } catch (e) {
            dispatch('notifyError', e)
        }
    },
    async updatePaymentGateway({ dispatch }, { id, data }) {
        try {
            await PaymentGateway.update(id, data)
            dispatch('notifySuccess', 'updated')
            return true
        } catch (e) {
            dispatch('notifyError', e)
        }
    },
    async updatePaymentGatewayBalance({ dispatch }, { id, data }) {
        try {
            await PaymentGateway.updateBalance(id, data)
            dispatch('notifySuccess', 'updated')
            return true
        } catch (e) {
            dispatch('notifyError', e)
        }
    },
    async getPaymentGatewayBalanceLogs({ commit, dispatch }, params) {
        commit('SET_IS_FETCHING_PAYMENT_GATEWAY_BALANCE_LOGS', true)
        try {
            const balanceLogs = await PaymentGateway.getBalanceLogs(params)
            commit('SET_PAYMENT_GATEWAY_BALANCE_LOGS', balanceLogs)
        } catch (e) {
            dispatch('notifyError', e)
        } finally {
            commit('SET_IS_FETCHING_PAYMENT_GATEWAY_BALANCE_LOGS', false)
        }
    },
    async getPaymentGatewayBalanceLogActors({ commit, dispatch }) {
        try {
            const actors = await PaymentGateway.getBalanceLogActors()
            commit('SET_PAYMENT_GATEWAY_BALANCE_LOG_ACTORS', actors || [])
        } catch (e) {
            dispatch('notifyError', e)
        }
    }
}
const getters = {
}

const state = {
    paymentGatewaySummaries: [],
    balanceLogs: { items: [], meta: {} },
    isFetchingBalanceLogs: false,
    balanceLogActors: []
}

export default {
    state,
    mutations,
    actions,
    getters,
}
